// Brand KYC endpoints. Relative to the `ops` base URL, so they are used with
// useAxios({ base: "ops" }) — never inline the path at the call site.
export const BRAND_KYC_ENDPOINTS = {
    detail: (brandId) => `accounts/v1/${brandId}/kyc`,
    // PATCH { kyc_status } — gated on at least one document existing.
    status: (brandId) => `accounts/v1/${brandId}/kyc/status`,
    // PATCH { kyc_docs: [{ name, url }] } — attaches what the uploader returned.
    docs  : (brandId) => `accounts/v1/${brandId}/kyc/docs`,
    // DELETE — removes one entry, by its `kyc_docs[]._id`. 404 when it is
    // already gone.
    doc   : (brandId, docId) => `accounts/v1/${brandId}/kyc/docs/${docId}`
};

// Storage folder the shared uploads service files brand KYC documents under.
export const KYC_UPLOAD_TYPE = "kyc_doc";

// Matches the server's own upload limit (UPLOAD_MAX_FILE_SIZE_MB).
export const KYC_MAX_SIZE_MB = 10;

// The extension is checked alongside the MIME type because scanned documents
// frequently arrive with an empty or generic `file.type`.
export const KYC_MIME_TYPES = ["application/pdf"];

export const KYC_EXTENSIONS = [".pdf"];

export const KYC_ACCEPT_ATTR = [...KYC_MIME_TYPES, ...KYC_EXTENSIONS].join(",");

export const KYC_DROPZONE_TITLE = "Drag & drop KYC documents, or click to browse";

// Each staged document must be named before upload; that name is what is
// attached to the brand, not the file name.
export const KYC_NAME_PLACEHOLDER = "Document name, e.g. PAN card";

export const KYC_DROPZONE_NOTE = `Supported file type: PDF · up to ${KYC_MAX_SIZE_MB} MB · reviewed before upload`;

// Terminal state: once ops has verified a brand's KYC, the status is locked —
// see STATUS_LOCKED_REASON.VERIFIED.
export const KYC_VERIFIED_STATUS = "verified";

// Why the status control is dead, so the card explains itself instead of
// offering a dropdown that cannot be honoured.
export const STATUS_LOCKED_REASON = {
    NO_DOCS : "Upload a KYC document before setting a status.",
    VERIFIED: "KYC is verified and locked. It cannot be changed from here."
};

export const DOCS_EMPTY_NOTE = "No documents uploaded yet.";

export const TIMELINE_EMPTY_NOTE = "No status changes yet.";
